import "./FoundersNotes.module.css";
import Header from "@/reusable_sections/Header";
import FoundersNotesHero from "./sections/FoundersNotesHero";
import FeaturedPostSection from "./sections/FeaturedPostSection";
import PostFeedSection from "./sections/PostFeedSection";
import CategoriesTagsFilterSection from "./sections/CategoriesTagsFilterSection";
import CallToActionSection from "./sections/CallToActionSection";
import EmailSignupSection from "./sections/EmailSignupSection";
import Footer from "@/reusable_sections/Footer";
export default function FoundersNotesPage() {
  return <div>
      <Header />
      <FoundersNotesHero />
      <FeaturedPostSection />
      <PostFeedSection />
      <CategoriesTagsFilterSection />
      <CallToActionSection />
      <EmailSignupSection />
      <Footer />
    </div>;
}